import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { THEMES } from 'root-constants'
import { PageIdWoofzPppBl } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_PPP_BL: Record<
  Exclude<PageIdWoofzPppBl, PageIdWoofzPppBl.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.DOG_AGE_WOOFZ_PPP_BL]: {
    id: PageId.DOG_AGE_WOOFZ_PPP_BL,
    headerId: HeaderId.LOGO_TITLE_MENU,
  },
  [PageId.DOG_OWNER_WOOFZ_PPP_BL]: {
    id: PageId.DOG_OWNER_WOOFZ_PPP_BL,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.TRAINING_COMMANDS_WOOFZ_PPP_BL]: {
    id: PageId.TRAINING_COMMANDS_WOOFZ_PPP_BL,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.URGE_WOOFZ_PPP_BL]: {
    id: PageId.URGE_WOOFZ_PPP_BL,
    headerId: HeaderId.BACK_MENU,
  },
  [PageId.DOG_BREED_WOOFZ_PPP_BL]: {
    id: PageId.DOG_BREED_WOOFZ_PPP_BL,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.FACING_CHALLENGES_WOOFZ_PPP_BL]: {
    id: PageId.FACING_CHALLENGES_WOOFZ_PPP_BL,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.FACING_CHALLENGES_2_WOOFZ_PPP_BL]: {
    id: PageId.FACING_CHALLENGES_2_WOOFZ_PPP_BL,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.BEHAVIOR_FREQUENCY_WOOFZ_PPP_BL]: {
    id: PageId.BEHAVIOR_FREQUENCY_WOOFZ_PPP_BL,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.URGE_PROGRAM_WOOFZ_PPP_BL]: {
    id: PageId.URGE_PROGRAM_WOOFZ_PPP_BL,
    headerId: HeaderId.BACK_LOGO_TITLE_MENU,
  },
  [PageId.BEHAVIOR_FEELINGS_WOOFZ_PPP_BL]: {
    id: PageId.BEHAVIOR_FEELINGS_WOOFZ_PPP_BL,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.FIX_BEHAVIOR_WOOFZ_PPP_BL]: {
    id: PageId.FIX_BEHAVIOR_WOOFZ_PPP_BL,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.URGE_4_WOOFZ_PPP_BL]: {
    id: PageId.URGE_4_WOOFZ_PPP_BL,
    headerId: HeaderId.BACK_LOGO_TITLE_MENU,
  },
  [PageId.COMMANDS_WOOFZ_PPP_BL]: {
    id: PageId.COMMANDS_WOOFZ_PPP_BL,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.PARENT_GOAL_WOOFZ_PPP_BL]: {
    id: PageId.PARENT_GOAL_WOOFZ_PPP_BL,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.TRAINING_PLACE_WOOFZ_PPP_BL]: {
    id: PageId.TRAINING_PLACE_WOOFZ_PPP_BL,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.TRAINING_FREQUENCY_WOOFZ_PPP_BL]: {
    id: PageId.TRAINING_FREQUENCY_WOOFZ_PPP_BL,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.URGE_5_WOOFZ_PPP_BL]: {
    id: PageId.URGE_5_WOOFZ_PPP_BL,
    headerId: HeaderId.BACK_LOGO_TITLE_MENU,
  },
  [PageId.PREPARE_FLOW_WOOFZ_PPP_BL]: {
    id: PageId.PREPARE_FLOW_WOOFZ_PPP_BL,
    headerId: HeaderId.BACK_LOGO_TITLE_MENU,
  },
  [PageId.COMMITMENT_SCREEN_PPP_BL]: {
    id: PageId.COMMITMENT_SCREEN_PPP_BL,
  },
  [PageId.EMAIL_WOOFZ_PPP_BL]: {
    id: PageId.EMAIL_WOOFZ_PPP_BL,
    headerId: HeaderId.BACK_LOGO_TITLE_MENU,
  },
  [PageId.NEWSLETTER_URGE_WOOFZ_PPP_BL]: {
    id: PageId.NEWSLETTER_URGE_WOOFZ_PPP_BL,
    headerId: HeaderId.BACK_LOGO_TITLE_MENU,
  },
  [PageId.LAST_CHANCE_OFFER_WOOFZ_PPP_BL]: {
    id: PageId.LAST_CHANCE_OFFER_WOOFZ_PPP_BL,
  },
  [PageId.SUBSCRIPTIONS_WOOFZ_PPP_BL]: {
    id: PageId.SUBSCRIPTIONS_WOOFZ_PPP_BL,
  },
  [PageId.CHAT_UPSELL_WOOFZ_PPP_BL]: {
    id: PageId.CHAT_UPSELL_WOOFZ_PPP_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_WOOFZ_PPP_BL]: {
    id: PageId.UPSELL_WOOFZ_PPP_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_FEEDING_GUIDE_WOOFZ_PPP_BL]: {
    id: PageId.UPSELL_FEEDING_GUIDE_WOOFZ_PPP_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_EMOTIONAL_SUPPORT_WOOFZ_PPP_BL]: {
    id: PageId.UPSELL_EMOTIONAL_SUPPORT_WOOFZ_PPP_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_WOOFZ_PPP_BL]: {
    id: PageId.DOWNLOAD_WOOFZ_PPP_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
